// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-dark-orange {
  color: #ff8c00 !important; /* DarkOrange */
}
.text-maroon {
  color: #800000 !important;
}
.text-inherit {
  color: inherit !important;
}
.age-card {
  background: #fff;
  height: 100px;
  border-radius: 12px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0,0,0,0.08);
  margin-right: 3px;
}

.age-card h2 {
  color: #3b82f6;
  font-weight: 700;
}

.age-card.danger h2 {
  color: #ef4444;
}

.age-card.active {
  border: 2px solid #3b82f6;
  transform: scale(1.03);
}
.hover-card {
  position: relative;
}

.hover-preview {
  display: none;
  position: absolute;
  bottom: -90px;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.15);
  z-index: 10;
}

.hover-card:hover .hover-preview {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/customer_app/Customer_V5/Material/ageingReport.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB,EAAE,eAAe;AAC5C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".text-dark-orange {\n  color: #ff8c00 !important; /* DarkOrange */\n}\n.text-maroon {\n  color: #800000 !important;\n}\n.text-inherit {\n  color: inherit !important;\n}\n.age-card {\n  background: #fff;\n  height: 100px;\n  border-radius: 12px;\n  padding: 10px;\n  text-align: center;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(0,0,0,0.08);\n  margin-right: 3px;\n}\n\n.age-card h2 {\n  color: #3b82f6;\n  font-weight: 700;\n}\n\n.age-card.danger h2 {\n  color: #ef4444;\n}\n\n.age-card.active {\n  border: 2px solid #3b82f6;\n  transform: scale(1.03);\n}\n.hover-card {\n  position: relative;\n}\n\n.hover-preview {\n  display: none;\n  position: absolute;\n  bottom: -90px;\n  left: 0;\n  width: 100%;\n  background: #fff;\n  padding: 10px;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px rgba(0,0,0,0.15);\n  z-index: 10;\n}\n\n.hover-card:hover .hover-preview {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
